import { render, staticRenderFns } from "./takeRedpack.vue?vue&type=template&id=5e71eff8&scoped=true&"
import script from "./takeRedpack.vue?vue&type=script&lang=js&"
export * from "./takeRedpack.vue?vue&type=script&lang=js&"
import style0 from "./takeRedpack.vue?vue&type=style&index=0&id=5e71eff8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e71eff8",
  null
  
)

export default component.exports